<template>
    <div class="diaoyan-box">
      <div style="text-align:left;color:#FFFFFF;">注：照片顺序不分先后，参照调研时间顺序排列</div>
        <div class="diaoyan-box-center">
          <div class="diaoyanItem" >
            <img :src="item.url" alt="" v-for="item in diaoyanList1" :key="item.id" :title="item.title">
          </div>
          <div class="diaoyanItem" >
            <img :src="item.url" alt="" v-for="item in diaoyanList2" :key="item.id" :title="item.title">
          </div>
          <div class="diaoyanItem" >
            <img :src="item.url" alt="" v-for="item in diaoyanList3" :key="item.id" :title="item.title">
          </div>
          <div class="diaoyanItem" >
            <img :src="item.url" alt="" v-for="item in diaoyanList4" :key="item.id" :title="item.title">
          </div>
          <div class="diaoyanItem" >
            <img :src="item.url" alt="" v-for="item in diaoyanList5" :key="item.id" :title="item.title">
          </div>
          <div class="diaoyanItem" >
            <img :src="item.url" alt="" v-for="item in diaoyanList6" :key="item.id" :title="item.title">
          </div>
        </div>
    </div>
  </template>
  
  <script>

  export default {
    name: 'diaoyan',
    data(){
        return{
            diaoyanList1:[
                {id:1,name:'7约4日白皮书研讨会.jpg',url:require('../../assets/images/diaoyan/7约4日白皮书研讨会.jpg'), title:'白皮书研讨会'},
                {id:2,name:'7约4日白皮书研讨会.jpg',url:require('../../assets/images/diaoyan/数字院李新平.jpg'), title:'李新平专家访谈'},
                {id:3,name:'7约4日白皮书研讨会.jpg',url:require('../../assets/images/diaoyan/物联网研究院.jpg'), title:'石家庄市物联网产业发展研究院于卫平院长访谈'},
                {id:4,name:'7约4日白皮书研讨会.jpg',url:require('../../assets/images/diaoyan/边存国.jpg'), title:'边存国专家访谈'},

            ],
            diaoyanList2:[
                {id:5,name:'7约4日白皮书研讨会.jpg',url:require('../../assets/images/diaoyan/生物医药产业园.jpg'), title:'生物医药产业园调研'},
                {id:6,name:'7约4日白皮书研讨会.jpg',url:require('../../assets/images/diaoyan/专家座谈会.jpg'), title:'专家座谈会'},
                {id:7,name:'7约4日白皮书研讨会.jpg',url:require('../../assets/images/diaoyan/河北科技大学信息工程学院.jpg'), title:'河北科技大学信息工程学院调研'},
                {id:8,name:'7约4日白皮书研讨会.jpg',url:require('../../assets/images/diaoyan/数学研究所.jpg'), title:'河北省科学院数学研究所调研'},

            ],
            diaoyanList3:[
                {id:9,name:'7约4日白皮书研讨会.jpg',url:require('../../assets/images/diaoyan/河钢数字.jpg'), title:'河钢数字调研'},
                {id:10,name:'7约4日白皮书研讨会.jpg',url:require('../../assets/images/diaoyan/河工吴满财.jpg'), title:'河北工程技术学院调研'},
                {id:11,name:'7约4日白皮书研讨会.jpg',url:require('../../assets/images/diaoyan/鸿联九五1.jpg'), title:'鸿联九五调研'},
                {id:12,name:'7约4日白皮书研讨会.jpg',url:require('../../assets/images/diaoyan/先河环保2.jpg'), title:'先河环保调研'}

            ],
            diaoyanList4:[
                {id:13,name:'7约4日白皮书研讨会.jpg',url:require('../../assets/images/diaoyan/河北大学.jpg'), title:'河北大学调研'},
                {id:14,name:'7约4日白皮书研讨会.jpg',url:require('../../assets/images/diaoyan/科林电器.jpg'), title:'科林电器调研'},
                {id:15,name:'7约4日白皮书研讨会.jpg',url:require('../../assets/images/diaoyan/科林电器2.jpg'), title:'科林电器调研'},
                {id:16,name:'7约4日白皮书研讨会.jpg',url:require('../../assets/images/diaoyan/塞克普泰.jpg'), title:'塞克普泰调研'},

            ],
            diaoyanList5:[
                {id:17,name:'7约4日白皮书研讨会.jpg',url:require('../../assets/images/diaoyan/经贸大学信息技术学院院长孙立辉.jpg'), title:'河北经贸大学信息技术学院调研'},
                {id:18,name:'7约4日白皮书研讨会.jpg',url:require('../../assets/images/diaoyan/生物医药产业园2.jpg'), title:'生物医药产业园调研'},
                {id:19,name:'7约4日白皮书研讨会.jpg',url:require('../../assets/images/diaoyan/石家庄学院未来信息技术学院.jpg'), title:'石家庄学院未来信息技术学院调研'},
                {id:20,name:'7约4日白皮书研讨会.jpg',url:require('../../assets/images/diaoyan/书博会发布.jpg'), title:'数博会概览版白皮书发布'},

            ],
            diaoyanList6:[
                {id:21,name:'7约4日白皮书研讨会.jpg',url:require('../../assets/images/diaoyan/河北师大.jpg'), title:'河北师范大学调研'},
                {id:22,name:'7约4日白皮书研讨会.jpg',url:require('../../assets/images/diaoyan/阿凯科技.jpg'), title:'阿凯科技调研'},
                {id:23,name:'7约4日白皮书研讨会.jpg',url:require('../../assets/images/diaoyan/保定电力.jpg'), title:'保定电力调研'},
                {id:24,name:'7约4日白皮书研讨会.jpg',url:require('../../assets/images/diaoyan/先河环保.jpg'), title:'先河环保调研'},

            ]
        }
    },
    mounted() {

}
  };
  </script>

<style scoped>
.diaoyan-box{
    width: 100%;
    height: 100%;
    /* background: pink; */
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
}
.diaoyan-box-center {
  width: 94%;
  height: 80%;
  /* background: blue; */
  overflow: auto;
}
.diaoyanItem {
  width: 100%;
  height: 30%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: space-between;
  flex-wrap: wrap;
  margin-top: 35px;
}
.diaoyanItem img {
  width:21%;
  height: 100%;
  box-sizing: border-box;
  margin-right: 60px;
  transition: all 0.9s;
}
.diaoyanItem img:nth-child(4n){
    margin-right: 0;
}
.diaoyanItem img:hover {
  transition: all 0.9s;
  box-shadow: 0 0 15px #fff;
  /* cursor: pointer; */
}
</style>